import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { DonutChartProps } from '../types/chartProps';
import { mergeWithDefaults } from '../utils/chartDefaults';
import { applyPieChartOptions, renderLabelsForPieChart } from '../utils/pieChartUtils';

export const DonutChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, DonutChartProps>((props, ref) => {
    const options: Highcharts.Options = applyPieChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'pie',
          marginBottom: 80,
          spacingTop: 10,
          events: {
            render: renderLabelsForPieChart(props)
          }
        }
      }),
      { ...props, innerSize: '80%' }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
